import React from 'react';
import s from './loading.scss';
type LoadingProps = {
  active: boolean
};
class Loading extends React.Component<LoadingProps, {}> {
  render() {
    const {active} = this.props;
    return (
      <div
        data-hooks="loading-screen"
        className={`${s.overlay} ${active ? s.active : ''}`}
      >
        <div className={`preloader ${s.loading}`}>
          <svg
            className={s.circle}
            version="1.1"
            width="32"
            height="32"
            viewBox="0 0 32 32"
          >
            <path d="M 11.673762078750737 29.31479122813215 A 14 14 0 1 0 16 2" />
          </svg>
          <svg
            className={s.dot}
            version="1.1"
            width="32"
            height="32"
            viewBox="0 0 32 32"
          >
            <path transform="translate(14,0)" d="M 3 2 A 1 1 0 0 0 3 2" />
            <path transform="translate(14,28)" d="M 3 2 A 1 1 0 0 0 3 2" />
          </svg>
        </div>
      </div>
    );
  }
}
export default Loading;
